import React from 'react';
import { useRouteError } from 'react-router-dom';
import { Paper, Stack } from '@mui/material';
import { sentry } from 'utils';
import { PageLayout } from 'components';
import * as views from './views';
import { is404 } from './is404';

export const ErrorPage = () => {
  const error = useRouteError();
  const ErrorView = is404(error) ? views.Error404 : views.UnexpectedError;

  React.useEffect(() => {
    if (error && !is404(error)) sentry.captureException(error);
  }, [error]);

  return (
    <PageLayout>
      <Paper sx={{ py: 10, px: 5 }}>
        <Stack spacing={5} alignItems="center">
          <ErrorView />
        </Stack>
      </Paper>
    </PageLayout>
  );
};
